import React from "react";
import five_slider_1 from '../../assets/five_slider_1.avif';
import five_slider_2 from '../../assets/five_slider_2.avif';
import five_slider_3 from '../../assets/five_slider_3.avif';
import five_slider_4 from '../../assets/five_slider_4.avif';
import five_slider_5 from '../../assets/five_slider_5.avif';
import five_slider_6 from '../../assets/five_slider_6.avif';
import five_slider_7 from '../../assets/five_slider_7.avif';
import five_slider_8 from '../../assets/five_slider_8.avif';
import five_slider_9 from '../../assets/five_slider_9.avif';
import five_slider_10 from '../../assets/five_slider_10.avif';
import five_slider_11 from '../../assets/five_slider_11.avif';
import five_slider_12 from '../../assets/five_slider_12.avif';
import five_slider_13 from '../../assets/five_slider_13.avif';
import five_slider_14 from '../../assets/five_slider_14.avif';
import five_slider_15 from '../../assets/five_slider_15.avif';
import five_slider_16 from '../../assets/five_slider_16.avif';
import five_slider_17 from '../../assets/five_slider_17.avif';
import five_slider_18 from '../../assets/five_slider_18.avif';
import five_slider_19 from '../../assets/five_slider_19.avif';
import five_slider_20 from '../../assets/five_slider_20.avif';
import five_slider_21 from '../../assets/five_slider_21.avif';
import five_slider_22 from '../../assets/five_slider_22.avif';
import five_slider_23 from '../../assets/five_slider_23.avif';
import five_slider_24 from '../../assets/five_slider_24.avif';

const treng_images = [
  five_slider_1, five_slider_2, five_slider_3, five_slider_4,
  five_slider_5, five_slider_6, five_slider_7, five_slider_8,
  five_slider_9, five_slider_10, five_slider_11, five_slider_12,
  five_slider_13, five_slider_14, five_slider_15, five_slider_16,
  five_slider_17, five_slider_18, five_slider_19, five_slider_20,
  five_slider_21, five_slider_22, five_slider_23, five_slider_24,
];

const titles = [
  'Буквы из пенопласта', 'SMM-продвижение', 'Контекстная реклама', 'Создание сайтов',
  'Видеопродакшн', 'Email-маркетинг', 'SEO-продвижение', 'Таргетированная реклама',
  'Разработка стратегии', 'Медийная реклама', 'PR-кампании', 'Аналитика данных',
  'Креативный дизайн', 'Лидогенерация', 'Омниканальный маркетинг', 'Нейминг и слоганы',
  'Продвижение в TikTok', 'Инфлюенс-маркетинг', 'Event-маркетинг', 'CRM-маркетинг',
  'Аудиовизуальный контент', 'Интерактивные форматы', 'Партнерские программы', 'Клиентский сервис',
];

const Icon = ({ name, size = 16 }) => {
  const common = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "shrink-0",
  };

  const paths = {
    arrow: <><path d="M5 12h13" /><path d="m13 6 6 6-6 6" /></>,
  };

  return <svg {...common}>{paths[name]}</svg>;
};

const TrendingMockupsBlock = () => {
  return (
    <section className="bg-bg pb-14 font-[Inter,Manrope,Arial,sans-serif] text-content">
      <div className="mx-auto max-w-[1240px] px-4">
        
        {/* Шапка блока */}
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4 border-b border-line pb-4">
          <div>
            <div className="mb-1 text-[10px] font-normal uppercase tracking-[.2em] text-accent">
              Тренды
            </div>
            <h2 className="text-2xl font-light tracking-tight text-content sm:text-3xl">
              Популярные направления
            </h2>
          </div>
          
          <button className="shine inline-flex items-center gap-2 rounded-lg bg-accent px-4 py-2 text-xs font-medium text-white transition hover:bg-accent-hover">
            Посмотреть все <Icon name="arrow" size={13} />
          </button>
        </div>

        {/* Сетка: 8 колонок для крупных экранов, 4 для планшетов, 2 для мобильных */}
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
          {treng_images.map((src, index) => (
            <article
              key={index}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-xl border border-line-strong bg-surface transition-all duration-300 hover:border-accent-hover hover:shadow-[0_10px_30px_rgba(0,0,0,0.06)]"
            >
              {/* Фотография */}
              <div className="aspect-square w-full overflow-hidden bg-surface">
                <img
                  src={src}
                  alt={titles[index]}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-105"
                />
              </div>

              {/* Текстовая часть */}
              <div className="flex flex-1 flex-col border-t border-surface-2 bg-surface p-3">
                <h3 className="line-clamp-2 text-[11px] font-medium leading-tight text-content transition-colors group-hover:text-accent-hover">
                  {titles[index]}
                </h3>
              </div>
            </article>
          ))}
        </div>

      </div>
    </section>
  );
};

export default TrendingMockupsBlock;